import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { listPayTargets } from './payTargets';
import { enqueueSnackbar } from './snackbar';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const listPayTargetsQuestions = () => (dispatch) => {
  const { payTargetsQuestions } = store.getState();
  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_LOADING,
  });
  return fetch
    .post('enverus/appTargetQuestions', {
      input: {
        active: payTargetsQuestions.activeState
      },
    })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_SUCCESS,
        payload: {
          data: data.map((item) => ({ ...item, _id: generateRandom() })),
          paginatedElements: data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const addNewQuestionRow = () => (dispatch) => {
  const { payTargetsQuestions } = store.getState();
  const newQuestions = [...payTargetsQuestions.data];
  const nextId = newQuestions.length - 1;

  const newRow = {
    question: '',
    referenceCategory: '',
    targetSpend: '',
    startDate: '',
    endDate: '',
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
  };

  newQuestions.unshift(newRow);

  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_SUCCESS,
    payload: {
      data: newQuestions,
      paginatedElements: newQuestions.length,
    },
  });
};

export const addPayTargetsQuestion = (data) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_LOADING,
  });
  return fetch
    .post('enverus/syncAppTargets', {
      input: data
    })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      dispatch(
        enqueueSnackbar(
          data?.message,
          'success',
          new Date().getTime() + Math.random()
        )
      );
      dispatch(listPayTargetsQuestions());
      dispatch(listPayTargets());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const deletePayTargetsQuestion = (question) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_LOADING,
  });
  return fetch
    .post('enverus/deleteAppTargets', {
      input: {
        question
      }
    })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      dispatch(
        enqueueSnackbar(
          data?.message,
          'success',
          new Date().getTime() + Math.random()
        )
      );
      dispatch(listPayTargetsQuestions());
      dispatch(listPayTargets());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const addSelectedRigsToTargetInRow = (data, selectedRigs, setRigsToTarget) => (dispatch) => {
  const { payTargetsQuestions } = store.getState();
  const currentQuestions = [...payTargetsQuestions.data];

  const updatedObject = {
    ...data,
    referenceCategory: '',
    targetSpend: '',
    startDate: '',
    endDate: '',
    rigs: selectedRigs,
  };

  const updatedQuestions = currentQuestions.map(item =>
    item._id === data?._id
      ? { ...updatedObject }
      : item
  );

  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_QUESTIONS_LIST_SUCCESS,
    payload: {
      data: updatedQuestions,
      paginatedElements: updatedQuestions.length,
    },
  });
  setRigsToTarget({ open: false, data: {} });
};
